import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Box from "@mui/material/Box";
import styled from "styled-components";
import { IconWrapper } from "../../styled/Tooltip.styled";

const StyledContainer = styled.div`
  width: 100%;
  margin-right: 5px;
`;

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

const StyledRadioGroup = styled(RadioGroup)`
  width: 100%;
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-left: 8px;
`;

const StyledRadio = styled(Radio)`
  & .MuiSvgIcon-root {
    font-size: 16px;
  }
  z-index: 0;
`;

const CommonRadioSelectGroup = ({ label, items = [], value, onChange }) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <StyledContainer>
      <StyledFormControl>
        {label && <Box
          component="legend"
          sx={{ typography: "subtitle1", mb: 1, fontSize: 14 }}
          style={{
            marginBottom: "10px !important",
            textAlign: "left",
            font: "normal normal 550 13px/18px Open Sans",
            color: "black"
          }}
        >
          {label}
        </Box>}
        <StyledRadioGroup
          column={value.toString()}
          aria-labelledby={label}
          name={label}
          value={value}
          onChange={handleChange}
        >
          {items &&
            items.length &&
            items.map((item, key) => (
              <div style={{ display: "flex", alignItems: "center" }} key={key}>
                <div>
                  {item.icon && (
                    <IconWrapper>
                      <img src={item.icon} alt="logo1" width="13" />
                    </IconWrapper>
                  )}
                </div>
                <div style={{ width: item.icon ? "95%" : "100%" }}>
                  <StyledFormControlLabel
                    value={item.value}
                    control={<StyledRadio />}
                    labelPlacement="start"
                    label={
                      <Box component="div" fontSize={13}>
                        {item.label}
                      </Box>
                    }
                    disabled={item.disabled}
                  />
                </div>
              </div>
            ))}
        </StyledRadioGroup>
      </StyledFormControl>
    </StyledContainer>
  );
};

export default CommonRadioSelectGroup;
